import React, { useState } from 'react';
import { Athlete } from '../atoms/athlete';
import { Button, Paper, Stack, TextField, Typography } from '@mui/material';
import Target from './Target';
import { useAtomValue } from 'jotai';
import { userAtom } from '../atoms/userAtom';
import UpdateTarget from './UpdateTarget';
import { Api } from '../providers/Api';

class Props {
    athlete: Athlete
    
}

const AthleteDisplay = (props: Props) => {
    const user = useAtomValue(userAtom);
    const [updProne,setUpdProne] = useState(false);
    const [updName,setUpdName] = useState(false);
    const [updStanding,setUpdStanding] = useState(false);
    const [newFName, setNewFName] = useState(props.athlete.firstName);
    const [newLName, setNewLName] = useState(props.athlete.lastName);
    const { athlete } = props;
    if (athlete) {
        return <Paper style={{ padding: 20 }}>
            {updName && <>
                    <TextField value={newFName} onChange={(ev) => {setNewFName(ev.target.value);}}/>
                    <TextField value={newLName} onChange={(ev) => {setNewLName(ev.target.value);}}/>
                        <Button onClick={async () => {
                            let backend = new Api();
                            let a = props.athlete;
                            a.firstName = newFName;
                            a.lastName = newLName;
                            await backend.updateAthlete(athlete);
                            setUpdName(false);
                        }}>Save</Button>
                        <Button onClick={() => {
                            setUpdName(false);
                            setNewFName(props.athlete.firstName);
                            setNewLName(props.athlete.lastName);
                        }}>Cancel</Button>
            </>}
            {!updName && <Typography variant='h2'>{athlete.firstName + " " + athlete.lastName} {user.role == "admin" && <Button onClick={() => {
                setNewFName(props.athlete.firstName);
                setNewLName(props.athlete.lastName);
                setUpdName(true)}}>Update</Button>}</Typography>}
            <Typography variant='h4'>{athlete.nationality}</Typography>
            <Typography variant='body2'>PRONE{athlete.prone && athlete.prone.name ? " (" + athlete.prone.name + ")" : ""}</Typography>
            
            {updProne && <UpdateTarget updatePattern={(patt)=>{}} pattern={athlete.prone?.pattern} cancel={() => {setUpdProne(false);}} save={async (newPattern: string) => {
                let backend = new Api();
                athlete.prone.pattern = newPattern;
                athlete.prone.name = new Date().toLocaleDateString();
                await backend.updateAthlete(athlete);
                setUpdProne(false);
            }}/>            
            }
            {!updProne && <Stack direction={"row"} spacing={2}><Target pattern={athlete.prone?.pattern} />
            {user.role == "admin" && <Button onClick={() => {setUpdProne(true)}}>Update</Button>}
            </Stack>}
            <Typography variant='body2'>STANDING{athlete.standing && athlete.standing.name ? " (" + athlete.standing.name + ")" : ""}</Typography>

            {updStanding && <UpdateTarget updatePattern={(patt)=>{}} pattern={athlete.standing?.pattern} cancel={() => {setUpdStanding(false);}} save={async (newPattern: string) => {
                let backend = new Api();
                athlete.standing.pattern = newPattern;
                athlete.standing.name = new Date().toLocaleDateString();
                await backend.updateAthlete(athlete);
                setUpdStanding(false);
            }}/>    
            }
            {!updStanding && <Stack direction={"row"} spacing={2}>
                <Target pattern={athlete.standing?.pattern} />
                {user.role == "admin" && <Button onClick={() => {setUpdStanding(true);}}>Update</Button>}
            </Stack>}
        </Paper>;
    }
    else {
        return null;
    }
}

export default AthleteDisplay;